import * as reportReasons from "shared/reportReasons";

/** Book feedback's ratings, or for a report, its reason instead. */
export type FeedbackRatings = {
  contentRating?: -1 | 0 | 1;
  languageRating?: -1 | 0 | 1;
  reportReason?: keyof typeof reportReasons.labels;
};

const ratingLabels: Record<string, string> = {
  "-1": "Bad",
  0: "Neutral",
  1: "Good",
};

/**
 * The Content and Language cells of a moderation table's feedback row, merged
 * into one that stands out for a report.
 */
export default function AdminFeedbackRatingCells({
  feedback,
}: {
  feedback: FeedbackRatings;
}) {
  if (feedback.reportReason) {
    return (
      <td colSpan={2} class="center">
        <strong class="reportReason">
          Report: {reportReasons.labels[feedback.reportReason]}
        </strong>
      </td>
    );
  }
  return (
    <>
      <td class="center">{ratingLabels[String(feedback.contentRating)]}</td>
      <td class="center">{ratingLabels[String(feedback.languageRating)]}</td>
    </>
  );
}
